import React, { lazy, Suspense, useCallback, useEffect, useRef, useState } from 'react';
import { Hero } from './components/sections/Hero';
import { Testimonials } from './components/sections/Testimonials';
import { SocialStats } from './components/sections/SocialStats';
import { Pain } from './components/sections/Pain';
const DeferredContent = lazy(() => import('./components/sections/DeferredContent').then(({
  DeferredContent: Content
}) => ({
  default: Content
})));
const SocialProofToast = lazy(() => import('./components/SocialProofToast').then(({
  SocialProofToast: Toast
}) => ({
  default: Toast
})));
export function App() {
  const deferredTriggerRef = useRef<HTMLDivElement>(null);
  const [shouldLoadDeferred, setShouldLoadDeferred] = useState(false);
  const [isDeferredReady, setIsDeferredReady] = useState(false);
  const [shouldFocusPricing, setShouldFocusPricing] = useState(false);
  const [shouldShowSocialProof, setShouldShowSocialProof] = useState(false);
  const revealPricing = useCallback(() => {
    setShouldFocusPricing(true);
    setShouldLoadDeferred(true);
  }, []);
  const markDeferredReady = useCallback(() => {
    setIsDeferredReady(true);
  }, []);
  useEffect(() => {
    const socialProofTimer = window.setTimeout(() => setShouldShowSocialProof(true), 2400);
    return () => window.clearTimeout(socialProofTimer);
  }, []);
  useEffect(() => {
    const trigger = deferredTriggerRef.current;
    if (!trigger) return undefined;
    if (!('IntersectionObserver' in window)) {
      setShouldLoadDeferred(true);
      return undefined;
    }
    const observer = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) return;
      setShouldLoadDeferred(true);
      observer.disconnect();
    }, {
      rootMargin: '280px 0px'
    });
    observer.observe(trigger);
    return () => observer.disconnect();
  }, []);
  useEffect(() => {
    if (!shouldFocusPricing || !isDeferredReady) return;
    const frame = window.requestAnimationFrame(() => {
      const pricing = document.getElementById('pricing');
      if (!pricing) return;
      pricing.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
      window.setTimeout(() => document.getElementById('pricing-title')?.focus(), 350);
      setShouldFocusPricing(false);
    });
    return () => window.cancelAnimationFrame(frame);
  }, [isDeferredReady, shouldFocusPricing]);
  return <main className="w-full min-h-full bg-transparent text-snow" data-id="element-0" data-mp="3gmfwjkl7xecq">
      <Hero onCta={revealPricing} data-id="element-1" data-mp="3bmjqzgwvhev2" />
      <Testimonials data-id="element-2" data-mp="3bncso3gz5e6c" />
      <SocialStats data-id="element-3" data-mp="3bo4lx7n3mztg" />
      <Pain data-id="element-4" data-mp="3bkgq21u6m1bk" />
      <div ref={deferredTriggerRef} className="h-px" aria-hidden="true" data-id="element-5" data-mp="3qb7m5m2t3mkh" />
      {shouldLoadDeferred && <Suspense fallback={<div className="min-h-px" aria-hidden="true" data-id="element-7" data-mp="3lk7kk3iqsgbn" />} data-id="element-6" data-mp="3lkr57rzs1itd">
          <DeferredContent onCta={revealPricing} onReady={markDeferredReady} data-id="element-8" data-mp="3limr6h85z3fd" />
        </Suspense>}
      {shouldShowSocialProof && <Suspense fallback={null} data-id="element-9" data-mp="2swljb1wzlnry">
          <SocialProofToast data-id="element-10" data-mp="2svjxq3ichivz" />
        </Suspense>}
    </main>;
}